import { SportClubsPage } from "./page";

export default SportClubsPage;
